import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'validateProfile',
    standalone: false
})
export class ValidateProfilePipe implements PipeTransform {

  transform(acceptable: string[], profiles: any[]): any {
    if (!acceptable || !profiles) {
      return false;
    }
    return acceptable.filter(item => profiles.find(item2 => item2 === item)).length !== 0;
  }

}
